import React from 'react';
import "./Home.scss";
import { Row, Col, Button } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';

export const Home = () => {
  const navigate = useNavigate();
  const userInfo = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;



  return (
    <div className="home-page">
      {/* Hero Banner Section */}
      <section className="hero-banner-section bg-white d-flex align-items-center py-5 position-relative">
        {/* Decorative shapes */}
        <div className="decorative-shapes position-absolute">
          <div className="shape shape-1 bg-warning rounded-circle" style={{ width: '100px', height: '100px', top: '10%', left: '5%', opacity: 0.1 }}></div>
          <div className="shape shape-2 bg-primary rounded-circle" style={{ width: '80px', height: '80px', top: '60%', right: '10%', opacity: 0.1 }}></div>
          <div className="shape shape-3 bg-success rounded-circle" style={{ width: '60px', height: '60px', top: '30%', right: '20%', opacity: 0.1 }}></div>
        </div>
        
        <div className="container-xl position-relative">
          <Row className="align-items-center gx-4 gy-5">
            <Col md={6}>
              <div data-aos="slide-right" className="content-wrapper text-center text-md-start">
                <div className="hero-heading lh-sm mb-4 text-dark fw-bold" style={{ fontSize: '3.5rem' }}>
                  Welcome to <span className="text-warning">Yoospeak</span>
                </div>
                <div className="description fs-5 mb-4 text-muted">
                  🌍 Learn. Teach. Connect. Earn. All in One Place.
                </div>
                <div className="description fs-6 mb-4 text-muted">
                  Yoospeak™ is the global app that helps you find teachers and find students instantly.<br/>
                  Message, video call, and practice anytime — all inside one simple platform.<br/>
                  Join classes, communities, or live sessions to learn, teach, and grow.
                </div>
                <div className="description fs-5 mb-4 text-warning fw-bold">
                  🔥 Start now — your global learning journey begins here!
                </div>
                <div className="btn-wrapper d-flex flex-wrap justify-content-center justify-content-md-start gap-3">
                  <Link className="text-md-end" to={'https://play.google.com/store/games'} target="_blank">
                    <img src={require('../../assets/images/play-store.png')} className="img-fluid rounded-3" alt='Google Play Store' />
                  </Link>
                  <Link to={'https://appstoreconnect.apple.com/login'} target="_blank">
                    <img src={require('../../assets/images/app-store.png')} className="img-fluid rounded-3" alt='App Store' />
                  </Link>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div data-aos="slide-left" className="img-wrapper text-center position-relative">
                <img src={require('../../assets/images/hero-banner-img1.png')} alt="Banner" className="img-fluid" style={{maxWidth:'400px'}} />
                {/* Speech bubble overlays */}
                <div className="speech-bubble speech-bubble-1 position-absolute bg-white rounded-4 p-3 shadow" style={{ 
                  top: '15%', 
                  right: '5%', 
                  maxWidth: '220px',
                  border: '2px solid #e9ecef'
                }}>
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <div className="avatar bg-primary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px' }}>
                      <span className="text-white small fw-bold">AS</span>
                    </div>
                    <div>
                      <div className="fw-bold small">Anna Smith</div>
                    </div>
                  </div>
                  <p className="small mb-2">Hi, I'm Anna Smith. I'm a mentor.</p>
                  <Button variant="primary" size="sm" className="w-100">View Profile</Button>
                </div>
                <div className="speech-bubble speech-bubble-2 position-absolute bg-white rounded-4 p-2 shadow" style={{ 
                  top: '45%', 
                  right: '15%', 
                  maxWidth: '120px',
                  border: '2px solid #e9ecef'
                }}>
                  <div className="text-center">
                    <i className="bi bi-chat-dots text-primary fs-4"></i>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* 1-on-1 and Group Classes Section */}
      <section className="our-feature-section py-5 bg-light position-relative">
        {/* Decorative shapes */}
        <div className="decorative-shapes position-absolute">
          <div className="shape shape-4 bg-warning rounded-circle" style={{ width: '120px', height: '120px', top: '20%', left: '3%', opacity: 0.1 }}></div>
          <div className="shape shape-5 bg-primary rounded-circle" style={{ width: '90px', height: '90px', top: '70%', right: '5%', opacity: 0.1 }}></div>
        </div>
        
        <div className="container-xl">
          <div className="text-center mb-5">
            <h2 className="section-title fw-bold text-dark">💬 1-on-1 and Group Classes</h2>
            <p className="text-muted fs-5">Learn your way — or start teaching yours.</p>
          </div>
          
          <Row className="gx-4 gy-4">
            <Col md={4}>
              <div className="feature-card bg-white rounded-4 p-4 shadow-sm h-100 text-center">
                <div className="feature-avatar bg-primary rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center" style={{ width: '80px', height: '80px' }}>
                  <i className="bi bi-people-fill text-white fs-2"></i>
                </div>
                <h4 className="feature-title mb-3 text-dark fw-bold">Find Certified Teachers</h4>
                <p className="text-muted mb-4">Students can find certified teachers for 1-on-1 or group classes.</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="feature-card bg-white rounded-4 p-4 shadow-sm h-100 text-center">
                <div className="feature-avatar bg-success rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center" style={{ width: '80px', height: '80px' }}>
                  <i className="bi bi-person-plus text-white fs-2"></i>
                </div>
                <h4 className="feature-title mb-3 text-dark fw-bold">Find New Students</h4>
                <p className="text-muted mb-4">Teachers can find new students ready to learn and book lessons.</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="feature-card bg-white rounded-4 p-4 shadow-sm h-100 text-center">
                <div className="feature-avatar bg-warning rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center" style={{ width: '80px', height: '80px' }}>
                  <i className="bi bi-chat-dots text-white fs-2"></i>
                </div>
                <h4 className="feature-title mb-3 text-dark fw-bold">Easy Communication</h4>
                <p className="text-muted mb-4">Chat, schedule, and meet directly inside the app for easy communication.</p>
              </div>
            </Col>
          </Row>
          <div className="text-center mt-4">
            <Button variant="primary" className="btn-custom fs-6 px-3 py-2">
              📲 DOWNLOAD NOW TO START LEARNING OR TEACHING
            </Button>
          </div>
        </div>
      </section>

      {/* Join or Create Communities Section */}
      <section className="find-mentors-section py-5 position-relative">
        {/* Decorative shapes */}
        <div className="decorative-shapes position-absolute">
          <div className="shape shape-6 bg-success rounded-circle" style={{ width: '100px', height: '100px', top: '10%', right: '8%', opacity: 0.1 }}></div>
          <div className="shape shape-7 bg-primary rounded-circle" style={{ width: '80px', height: '80px', top: '80%', left: '3%', opacity: 0.1 }}></div>
        </div>
        
        <div className="container-xl">
          <Row className="align-items-center gx-4 gy-5">
            <Col md={6}>
              <div className="feature-content">
                <h3 className="feature-title mb-3 text-dark fw-bold">👥 Join or Create Communities</h3>
                <p className="text-muted mb-4 fs-5">Practice together, share ideas, and stay connected.</p>
                <ul className="text-muted mb-4 fs-6">
                  <li>Join or create communities for language exchange, study, or culture.</li>
                  <li>Post, comment, message, and organize live group discussions.</li>
                  <li>Communities can be free or paid — the choice is yours.</li>
                </ul>
                <Button variant="primary" className="btn-custom fs-6 px-3 py-2">
                  📲 DOWNLOAD NOW TO JOIN A COMMUNITY
                </Button>
              </div>
            </Col>
            <Col md={6}>
              <div className="feature-image text-center">
                <img src={require('../../assets/images/meet-teacher.png')} className="img-fluid" alt="Join Communities" style={{maxWidth: '400px'}} />
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Go Live and Share Knowledge Section */}
      <section className="travel-abroad-section py-5 bg-light position-relative">
        {/* Decorative shapes */}
        <div className="decorative-shapes position-absolute">
          <div className="shape shape-8 bg-warning rounded-circle" style={{ width: '110px', height: '110px', top: '15%', left: '2%', opacity: 0.1 }}></div>
          <div className="shape shape-9 bg-success rounded-circle" style={{ width: '70px', height: '70px', top: '75%', right: '4%', opacity: 0.1 }}></div>
        </div>
        
        <div className="container-xl">
          <Row className="gx-4 gy-5">
            <Col md={6}>
              <div className="travel-card bg-white rounded-4 p-4 shadow-sm h-100">
                <h3 className="feature-title mb-3 text-dark fw-bold">🎥 Go Live and Share Knowledge</h3>
                <div className="landmark-image mb-4 position-relative">
                  <img src={require('../../assets/images/join-live-session.png')} className="img-fluid rounded-3" alt="Go Live" style={{ maxWidth: '250px' }} />
                  <div className="graduation-cap position-absolute" style={{ top: '10px', right: '10px' }}>
                    <i className="bi bi-camera-video-fill text-warning fs-3"></i>
                  </div>
                </div>
                <ul className="text-muted mb-4 fs-6">
                  <li>Only approved teachers can host live sessions and share lessons.</li>
                  <li>Students can join, comment, and participate during live classes.</li>
                  <li>Support creators by sending virtual gifts or subscribing to their streams.</li>
                  <li>Yoospeak makes live learning fun, interactive, and safe.</li>
                </ul>
                <Button variant="primary" className="btn-custom fs-6 px-3 py-2">
                  📲 DOWNLOAD NOW TO GO LIVE
                </Button>
              </div>
            </Col>
            <Col md={6}>
              <div className="welcome-card bg-white rounded-4 p-4 shadow-sm h-100">
                <h3 className="feature-title mb-3 text-dark fw-bold">💳 Earn and Grow</h3>
                <p className="text-muted mb-4 fs-5">Whether you're a teacher or learner, you can earn on Yoospeak.</p>
                <ul className="text-muted mb-4 fs-6">
                  <li>Get paid for private lessons, community memberships, or live events.</li>
                  <li>All payments are secure and transparent through Stripe Connect.</li>
                  <li>Build your brand, track your progress, and grow your income easily.</li>
                </ul>
                <Button variant="primary" className="btn-custom fs-6 px-3 py-2">
                  📲 DOWNLOAD NOW TO START EARNING
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Learn Any Language & Safe and Verified Section */}
      <section className="choose-classes-section py-5 position-relative">
        {/* Decorative shapes */}
        <div className="decorative-shapes position-absolute">
          <div className="shape shape-10 bg-primary rounded-circle" style={{ width: '100px', height: '100px', top: '20%', right: '5%', opacity: 0.1 }}></div>
          <div className="shape shape-11 bg-warning rounded-circle" style={{ width: '80px', height: '80px', top: '70%', left: '3%', opacity: 0.1 }}></div>
        </div>
        
        <div className="container-xl">
          <Row className="align-items-center gx-4 gy-5">
            <Col md={6}>
              <div className="feature-content">
                <h3 className="feature-title mb-3 text-dark fw-bold">🧠 Learn Any Language</h3>
                <p className="text-muted mb-4 fs-5">Yoospeak™ supports learning and teaching in every language.</p>
                <ul className="text-muted mb-4 fs-6">
                  <li>Our multilingual interface makes communication easy for everyone.</li>
                  <li>Switch your app language anytime and connect globally with confidence.</li>
                </ul>
                <Button variant="primary" className="btn-custom fs-6 px-3 py-2">
                  📲 DOWNLOAD NOW TO LEARN FREELY
                </Button>
              </div>
            </Col>
            <Col md={6}>
              <div className="feature-content">
                <h3 className="feature-title mb-3 text-dark fw-bold">🔐 Safe and Verified</h3>
                <p className="text-muted mb-4 fs-5">Trust and safety come first.</p>
                <ul className="text-muted mb-4 fs-6">
                  <li>Only verified users aged 18+ can teach or go live.</li>
                  <li>All teachers are certified, approved, and identity-verified.</li>
                  <li>Your privacy is protected with strong moderation and secure tools.</li>
                </ul>
                <Button variant="primary" className="btn-custom fs-6 px-3 py-2">
                  📲 DOWNLOAD NOW — SAFE & VERIFIED
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Join the Yoospeak Revolution Section */}
      <section className="ready-to-start-section position-relative py-5">
        <div className="container-fluid p-0">
          <div className="cta-banner position-relative">
            <img src={require('../../assets/images/practice-together.jpg')} alt="Join the Yoospeak Revolution" className="img-fluid w-100" style={{ height: '400px', objectFit: 'cover' }} />
            <div className="cta-overlay position-absolute top-50 start-50 translate-middle text-center">
              <h2 className="text-white fw-bold mb-3">🌎 Join the Yoospeak Revolution</h2>
              <p className="text-white mb-3 fs-5">Find teachers. Find students.</p>
              <p className="text-white mb-3">Message them, call them, and practice together anytime.</p>
              <p className="text-white mb-3">Join classes, communities, and live events — all in one global platform.</p>
              <p className="text-white mb-4 fs-5 fw-bold">Yoospeak™ isn't just an app — it's your worldwide classroom.</p>
              <p className="text-warning mb-4 fs-4 fw-bold">🔥 Learn. Teach. Connect. Earn.</p>
              <Button variant="warning" size="lg" className="btn-custom px-4 py-2 fw-bold fs-5 d-flex align-items-center gap-2 mx-auto download-btn-responsive">
                <span className="download-text">📲 DOWNLOAD YOOSPEAK NOW</span>
                <i className="bi bi-arrow-right fs-6"></i>
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Us Section */}
      <section className="contact-section py-5 bg-light">
        <div className="container-xl">
          <div className="text-center mb-5">
            <h2 className="section-title fw-bold text-dark">📞 Contact Us</h2>
            <p className="text-muted fs-5">Need support or more info? We're here to help.</p>
          </div>
          <Row className="justify-content-center">
            <Col md={8}>
              <div className="contact-card bg-white rounded-4 p-5 shadow-sm text-center">
                <div className="contact-info mb-4">
                  <div className="contact-item mb-3">
                    <i className="bi bi-telephone-fill text-primary fs-3 me-3"></i>
                    <span className="fs-5 fw-bold">Phone: +1 (888) 423-7610</span>
                  </div>
                  <div className="contact-item mb-4">
                    <i className="bi bi-envelope-fill text-primary fs-3 me-3"></i>
                    <span className="fs-5 fw-bold">Email: Support@yoospeak.app</span>
                  </div>
                </div>
                <Button variant="primary" className="btn-custom fs-6 px-3 py-2 download-btn-responsive">
                  <span className="download-text-small">📲 DOWNLOAD YOOSPEAK NOW</span>
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  )
}
